'use client';

import { Spinner } from '@/components/ui/spinner';

/** Salida hacia el checkout de Mercado Pago (link de pago). */
export function CheckoutMpRedirectStep() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-4 py-20 text-center">
      <Spinner className="size-12" />
      <h3 className="text-3xl font-bold">Redirigiendo a Mercado Pago...</h3>
      <p className="max-w-sm text-lg text-muted-foreground">Serás redirigido de forma segura para completar tu pago.</p>
    </div>
  );
}
